import axios from '@/axios-instance-node'

export interface HttpDeleteSubgeoParams {
	urlParams: {
		id: string
	}
}

export const httpDeleteSubgeo = async ({
	urlParams
}: HttpDeleteSubgeoParams) => {
	await axios.delete(`/v1/geo-mapping-sub-geos/${urlParams.id}`)
}
